import React from 'react';
import { Skeleton } from 'antd';
import classNames from 'classnames';
import { useRouter } from 'next/router';
import { useTranslations } from 'next-intl';

import { ResponsiveLineChart, useUserProfileStats } from 'modules/cabinet';

const ExperienceChart = () => {
  const t = useTranslations();
  const { query } = useRouter();
  const { data: userStats, isLoading: userStatsLoading } = useUserProfileStats();

  return (
    <div className="rounded-xl bg-white p-6 shadow-sm">
      {userStatsLoading ? (
        <div>
          <div className="flex justify-between">
            <Skeleton.Button className="!h-5 !w-40" active />
            <Skeleton.Button className="!w-30 !h-5" active />
          </div>
          <div className="mt-5 space-y-8">
            {Array.from({ length: 4 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <Skeleton.Button key={index} className="!h-3 !w-full" active />
            ))}
          </div>
        </div>
      ) : (
        <>
          <div className="flex flex-col justify-between lg:flex-row lg:items-center">
            <div className="text-md lg:text-lg">{t('profile.right_side.hafta_davomida_tajriba')}</div>
            <div className="mt-2 flex flex-col gap-1 lg:flex-row lg:items-center lg:gap-3">
              {query.id &&
                userStats?.map((stat, index) => (
                  <React.Fragment key={stat.id}>
                    <div className="flex items-center justify-between lg:px-2">
                      <span
                        className={classNames('text-sm', {
                          'text-gray-400': stat?.mine,
                          'text-green-500': !stat?.mine
                        })}
                      >
                        {stat?.mine ? t('siz') : stat?.full_name}
                      </span>
                      <div
                        className={classNames('text-sm lg:ml-1.5', {
                          'text-gray-400': stat?.mine,
                          'text-green-500': !stat?.mine
                        })}
                      >
                        {stat?.ball} xp
                      </div>
                    </div>

                    {index < userStats.length - 1 && (
                      <div className="hidden lg:block sm:h-5 sm:border-l-2 sm:border-gray-200" />
                    )}
                  </React.Fragment>
                ))}
            </div>
          </div>

          <div className="h-50 mt-5">{userStats && <ResponsiveLineChart userStats={userStats} />}</div>
        </>
      )}
    </div>
  );
};

export default ExperienceChart;
